// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Logo-link-3RXoO {\n  display: block;\n  padding-right: 5px;\n}\n.Logo-link-3RXoO:focus {\n  outline: none;\n  box-shadow: 0 0 0 2px #0071d4;\n  border-radius: 5px;\n}\n.Logo-link-3RXoO:has(.Logo-logoCustom-8ar8R) {\n  display: flex;\n  justify-content: center;\n}\n.Logo-linkIconOnly-2sWnc {\n  padding: 0;\n}\n.Logo-logo-2LCi- {\n  display: block;\n}\n.Logo-logoFull-2u7_w {\n  width: 100%;\n}\n.Logo-logoIconOnly-3lXpW {\n  max-height: 100%;\n  max-width: 100%;\n}\n.Logo-logoCustom-8ar8R {\n  max-width: 100%;\n  object-fit: scale-down;\n  max-height: 40px;\n}\n.Logo-logoCustomIconOnly-INZ-0 {\n  max-width: min(100px, 100%);\n  max-height: 100%;\n}\n", ""]);
// Exports
exports.locals = {
	"link": "Logo-link-3RXoO",
	"logoCustom": "Logo-logoCustom-8ar8R Logo-logo-2LCi-",
	"linkIconOnly": "Logo-linkIconOnly-2sWnc Logo-link-3RXoO",
	"logo": "Logo-logo-2LCi-",
	"logoFull": "Logo-logoFull-2u7_w Logo-logo-2LCi-",
	"logoIconOnly": "Logo-logoIconOnly-3lXpW Logo-logo-2LCi-",
	"logoCustomIconOnly": "Logo-logoCustomIconOnly-INZ-0 Logo-logoCustom-8ar8R Logo-logo-2LCi-"
};
module.exports = exports;
